import React, { useEffect, useRef, useState } from 'react'
import wifyBatteryIcon from '../../../../../src/assets/images/products/wify_batttery_icon.png'
import prevArrow from '../../../../../src/assets/images/prevArrow.png'
import decor from '../../../../../src/assets/images/lumi_decor.png'
import contactIcon from '../../../../../src/assets/images/contact_icon_white.png'
import connectButton from '../../../../../src/assets/images/app_connect_btn.png'
import sliderdotImage from '../../../../../src/assets/images/slider_dot_img.png'
import DateService from '../../../../Services/DateService';
import locationIcon from '../../../../../src/assets/images/location_icon.png'
import backButtonListing from '../../../../../src/assets/images/products/back_button_listing.png'
import verifiedIcon from '../../../../../src/assets/images/products/star_verified.png'

const ListingView = ({ children, currentTime, data = [], className }) => {

    let [parent, child] = [useRef(), useRef()]
    const [scrollArrowVisible, setScrollArrowVisible] = useState(false)

    // Generate random match percentage between 20 and 90
    const getRandomMatchPercentage = () => {
        return Math.floor(Math.random() * (90 - 20 + 1)) + 20;
    }

    // Get color based on match percentage
    const getMatchPercentageColor = (percentage) => {
        if (percentage < 30) {
            return '#FF8888'; // Red for below 30
        } else if (percentage >= 30 && percentage <= 40) {
            return '#E2B339'; // Yellow/orange for 30-40
        } else if (percentage >= 80) {
            return '#17953A'; // Green for 80+
        }
        return ''; // Default color for other ranges
    }

    const formatHeightLabel = (heightData) => {
        if (!heightData) return null;
        
        let heightLabel = '';
        if (typeof heightData === 'object' && heightData.label) {
            heightLabel = heightData.label;
        } else if (typeof heightData === 'string') {
            heightLabel = heightData;
        } else {
            return null;
        }

        let text = heightLabel.trim();

        // If format like "124 cm / 4 ft 1 in" -> take part after '/'
        if (text.includes('/')) {
            const parts = text.split('/');
            text = parts[parts.length - 1].trim();
        }

        // If format like "4 ft 1 in" or "4ft 1in" -> convert to 4'1"
        const feetInchesMatch = text.match(/(\d+)\s*ft\s*(\d+)\s*in/i);
        if (feetInchesMatch) {
            const [, ft, inch] = feetInchesMatch;
            return `${ft}'${inch}"`;
        }

        // If already in the correct format (e.g., "4'1""), return as is
        if (text.match(/^\d+'\d+"$/)) {
            return text;
        }

        // Fallback: remove any trailing cm portion if provided first
        const cmRemoved = text.replace(/\b\d+\s*cm\b.*$/i, '').trim();
        return cmRemoved || text;
    }

    // Helper function to calculate age from date of birth
    const calculateAge = (dob) => {
        if (!dob) return 0;
        
        try {
            const date = new Date(dob);
            if (isNaN(date.getTime())) {
                return 0;
            }

            const today = new Date();
            let age = today.getFullYear() - date.getFullYear();
            const monthDiff = today.getMonth() - date.getMonth();
            
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }
            
            return age;
        } catch (error) {
            console.error('Error calculating age:', error);
            return 0;
        }
    };

    useEffect(() => {
        if (parent.current && child.current) {
            const parentHeight = parent.current.offsetHeight;
            const childHeight = child.current.offsetHeight;
            setScrollArrowVisible(childHeight + 50 < parentHeight)
        }
    }, [parent, child]);
    return (
        <>
            {
                !data.length ? (
                    <div className="app">
                        <div className="listing_view">
                            <header className="app__header transparent">
                                <div className="app__header__top">
                                    <span className="app__header__top__time dark">{currentTime || '12:34'}</span>
                                    <div className="app__header__top__icons">
                                        <img src={wifyBatteryIcon} alt="" />
                                    </div>
                                </div>
                            </header>
                            <main className="app__main" style={{ paddingTop: "2rem" }}>
                                <div className="app__matches-container">
                                    <div className="app__header transparent app__header___top">
                                        <div className="app__back-button">
                                            <img src={prevArrow} alt="" />
                                        </div>
                                        <div className="app__title">Matches</div>
                                        <div className="app__heart-button">
                                            <img src={decor} alt="" />
                                        </div>
                                    </div>
                                    <div className="app__matches-list">
                                        {children && (
                                            <div className="app__match-card dynamic">
                                                {children}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                ) : (
                    <div className={`app`} ref={parent}>
                        <div className={`listing_view ${className} ${scrollArrowVisible && 'scrollable_arrow'} `} ref={child}>
                            <header className="app__header transparent">
                                <div className="app__header__top">
                                    <span className="app__header__top__time dark">{currentTime}</span>
                                    <div className="app__header__top__icons">
                                        <img src={wifyBatteryIcon} alt="" />
                                    </div>
                                </div>
                            </header>
                            <main className="app__main" style={{ paddingTop: 0 }}>
                                <div className="app__matches-container">
                                    <div className="app__header transparent app__header___top">
                                        <div className="listing_view_top">
                                            <img src={backButtonListing} alt="" />
                                        </div>

                                    </div>
                                    <div className="app__matches-list">
                                        {children && (
                                            <div className="app__match-card dynamic current-user-profile">
                                                {children}
                                            </div>
                                        )}
                                        {data.map((match, index) => {
                                            // Check if this is a duplicate of the current user profile
                                            const isCurrentUserProfile = match._id && match._id.toString().includes('preview_');
                                            const isDuplicateProfile = isCurrentUserProfile && children;
                                            
                                            return (
                                                <React.Fragment key={index}>
                                                    {match._id && match.profile_images && match.profile_images.length > 0 && !isDuplicateProfile && (
                                                        <div className={`app__match-card ${isCurrentUserProfile ? 'current-user-data' : 'mock-profile'}`}>
                                                            <div className="app__match-image">
                                                                {match.profile_images.map((el, idx) => (
                                                                    <img className='cover' key={idx} src={el.original} alt={`Profile ${idx}`} />
                                                                ))}
                                                                <span className='app__contact_icon'>
                                                                    <img src={contactIcon} alt="contact icon" />
                                                                </span>
                                                            </div>
                                                            <div className="app__match-info">
                                                                {(() => {
                                                                    const percentage = getRandomMatchPercentage();
                                                                    const backgroundColor = getMatchPercentageColor(percentage);
                                                                    return (
                                                                        <>
                                                                            <div className='match_percentage_wrap'>
                                                                            <div className="match_percentage">
                                                                                <span style={{ backgroundColor: backgroundColor }}>{percentage}%</span>
                                                                                <span>Match</span>
                                                                            </div>
                                                                            <span className='verified_icon'>
                                                                                <img src={verifiedIcon} alt="verified icon" />
                                                                            </span>
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                                <div className="app__match-id">{match.lumi_id}</div>
                                                                <div className="app__match-name semibold">{match.name}</div>
                                                                <div className="app__match-details">
                                                                    <div className='app__info_wrap'>
                                                                        <div className="app__match-age">{match.age || calculateAge(match.dob)} yrs</div>
                                                                        <span className="divider text_red">|</span>
                                                                        <div className="app__match-height">{formatHeightLabel(match.height)}</div>
                                                                        <span className="divider text_red">|</span>
                                                                        <div className="app__match-status">{match.marital_status?.label || match.marital_status}</div>
                                                                    </div>
                                                                    <div className="app__match-religion">{match.religion?.label}</div>
                                                                    <div className="app__match-profession">{match.job?.label}</div>
                                                                    <div className="short_location_wrap">
                                                                        <span><img src={locationIcon} alt="location icon" /></span>
                                                                        <div className="app__match-location">
                                                                            {match.city?.name ||
                                                                                match.city?.city?.label ||
                                                                                match.city?.label ||
                                                                                match.city?.display_place ||
                                                                                match.city?.display_name ||
                                                                                match.location ||
                                                                                'Location not specified'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="app__match-connect">
                                                                        <img src={connectButton} alt="connect button" />
                                                                    </div>
                                                                    <span className='slider_dot'>
                                                                        <img src={sliderdotImage} alt="slider dot" />
                                                                    </span>
                                                                </div>
                                                                <div className="app__match-last-online">
                                                                    Last online: {DateService.formatDateCustom(match.last_login)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>

                                </div>
                            </main>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default ListingView
